import { render, staticRenderFns } from "./verisureveiligBedankt.vue?vue&type=template&id=9830d54e"
import script from "./verisureveiligBedankt.vue?vue&type=script&lang=js"
export * from "./verisureveiligBedankt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports